import { render } from "./PreviewAccountingReceipt.vue?vue&type=template&id=90bb3c38&scoped=true&ts=true"
import script from "./PreviewAccountingReceipt.vue?vue&type=script&lang=ts"
export * from "./PreviewAccountingReceipt.vue?vue&type=script&lang=ts"

import "./PreviewAccountingReceipt.vue?vue&type=style&index=0&id=90bb3c38&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90bb3c38"]])

export default __exports__